/**
 * ShareMetaTags Component
 * Simple meta tags for sharing - text and URL only (no rich preview cards)
 */

import { useEffect } from 'react';

interface ShareMetaTagsProps {
  title?: string;
  description?: string;
  url?: string;
}

export function ShareMetaTags({
  title = 'Fun with AI - 餐厅推荐',
  description = '发现您附近的优质餐厅推荐',
  url,
}: ShareMetaTagsProps) {
  useEffect(() => {
    // Get current URL
    const currentUrl = url || window.location.href;

    // Function to update or create meta tag
    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic Open Graph tags (text and URL only, no image)
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:url', currentUrl);
    updateMetaTag('og:type', 'website');

    // Standard meta tags
    updateMetaTag('description', description, false);

    // Update page title
    document.title = title;

    // Cleanup function to restore defaults (optional)
    return () => {
      // You can restore default meta tags here if needed
    };
  }, [title, description, url]);

  return null; // This component doesn't render anything
}

